import React from 'react';

interface ArrayFieldEditorProps {
  label: string;
  field: string;
  items: string[];
  onChange: (items: string[]) => void;
  errors?: string[];
}

const ArrayFieldEditor: React.FC<ArrayFieldEditorProps> = ({
  label,
  items,
  onChange,
  errors,
}) => {
  const handleAdd = () => {
    onChange([...items, '']);
  };

  const handleChange = (index: number, value: string) => {
    const newItems = [...items];
    newItems[index] = value;
    onChange(newItems);
  };

  const handleRemove = (index: number) => {
    const newItems = items.filter((_, i) => i !== index);
    onChange(newItems);
  };

  return (
    <div className="form-group mb-3">
      <label className="form-label fw-semibold">{label}</label>
      <div className="mb-2">
        <button
          type="button"
          className="btn btn-sm btn-outline-primary"
          onClick={handleAdd}
        >
          <i className="fas fa-plus"></i> 追加
        </button>
      </div>
      <div className="items-container">
        {items.map((item, index) => (
          <div key={index} className="nested-fields mb-2 d-flex">
            <input
              type="text"
              className={`form-control ${errors ? 'is-invalid' : ''}`}
              value={item}
              onChange={(e) => handleChange(index, e.target.value)}
            />
            <button
              type="button"
              className="btn btn-sm btn-outline-danger ml-2"
              onClick={() => handleRemove(index)}
            >
              <i className="fas fa-times"></i>
            </button>
          </div>
        ))}
      </div>
      {errors && errors.length > 0 && (
        <div className="invalid-feedback d-block">{errors.join(', ')}</div>
      )}
    </div>
  );
};

export default ArrayFieldEditor;



